import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams} from 'ag-grid-community';
import * as _ from 'lodash';
import { SquirrelSessionRequest } from 'projects/shared/src/lib/models/SquirrelSession';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { ProjectService } from 'projects/shared/src/lib/services/project.service';
import { SquirrelManagementService } from 'projects/shared/src/lib/services/squirrel-management.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'user-projects-button-renderer',
  templateUrl: './user-projects-button-renderer.component.html',
  styleUrls: ['./user-projects-button-renderer.component.scss']
})
export class UserProjectsButtonRendererComponent implements ICellRendererAngularComp {

  params: any;
  routerLinkValue!:string;
  icon_view!: string;
  icon_doc!: string;
  icon_topic!: string;


  constructor(
    public translate: TranslateService,
    private tenantService: TenantService,
    private managementService: SquirrelManagementService,
    private projectService: ProjectService,
    private notificationService: NotificationService,
  ){}

  refresh(params: ICellRendererParams): boolean {
    const dataParams = params.colDef?.cellRendererParams;
    this.routerLinkValue = _.isFunction(dataParams.routerLinkValue) ? dataParams.routerLinkValue(params) : _.get(params.data, dataParams.routerLinkValue);
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.icon_view = this.params.icon_view;
    this.icon_doc = this.params.icon_doc;
    this.icon_topic = this.params.icon_topic;
    this.routerLinkValue = this.params.routerLinkValue || null;
    this.refresh(params);
  }

  
  onClick($event: any) {
    if(this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
      }

      console.log(params)

      this.params.onClick(this.params);
    }
  }

  // alter Übergang zum Projekt: geht jetzt nur über onRowClicked in project-list Komponente
  viewModels(target: string, event: any) {
    
    const rowData = [this.params.node.data];

    let db:string = this.tenantService.currentTenantName;
    this.managementService.GetSq3ProjectAuthentification(db, rowData[0].id).subscribe({ 
      next: (projAuth) => {
        //console.log("-------> user-projects-button-renderer Project Url: ", `${projAuth.frontendurl}/${target}/?frontendkey=${projAuth.frontendkey}`);
        window.open(`${projAuth.frontendurl}/${target}/?frontendkey=${projAuth.frontendkey}`, '_blank');
      },
      error: () => {
        this.notificationService.error(`${this.translate.data["ERROR"]}`, "management project authentication error")
      }
    })
    if (event) event.stopPropagation();
  }
}
